import GooglePlacesAutocomplete from "react-google-places-autocomplete";

export default function GoogleAutoComplete({ selectProps }) {
  return (
    <GooglePlacesAutocomplete
      apiKey="AIzaSyADhEQBb77x8axWW6tdxy-9tKQ2z5ZXgm0"
      selectProps={{ ...selectProps, className: "wrap-words" }}
      onLoadFailed={(error) => {
        console.error("Could not inject Google script", error);
      }}
    />
  );
}
